import configTasks from "../config";
import callback from "../../../utils/prototypeDefinitions/Date.prototype.addDays";
import { lStorage } from "../../../utils/localStorage/lStorage";

callback();

const oneDayInMiliseconds = 86400000;
const allowedFluff = oneDayInMiliseconds;

const getRealDate = (notRealDate) => new Date(notRealDate * allowedFluff);
const getFluffedStamp = (date = new Date()) =>
  Math.floor(date.getTime() / allowedFluff);

export const loadChecked = async () => {
  const rawTasks = (await lStorage.get("stats/accumulative")) ?? [];
  // const rawTasks = [
  //   {
  //     id: "01",
  //     lsm: 455184, // last checked moment
  //     cm: [455164, 455174, 455184], // checked moments
  //   },
  //   {
  //     id: "02",
  //     lsm: 455184,
  //     cm: [455164, 455174, 455184],
  //   },
  // ];

  const tasks = configTasks.map((task) => {
    const thisInChecked = rawTasks.find(({ id }) => task.id === id);

    const preparedTask = {
      id: task.id,
      title: task.title,
      rule: task.rule,
    };

    if (task.link) {
      preparedTask.link = task.link;
    }

    if (thisInChecked) {
      preparedTask.lastCheckedMoment = getRealDate(thisInChecked.lsm);
      preparedTask.checkedMoments = thisInChecked.cm.map((m) => getRealDate(m));
    } else {
      preparedTask.lastCheckedMoment = new Date().addDays(-30);
      preparedTask.checkedMoments = [preparedTask.lastCheckedMoment];
    }

    return preparedTask;
  });

  return tasks ?? [];
};

const getTasksByFrequency = (checkedTasks) => {
  return checkedTasks
    .filter((task) => task?.rule?.type === "frequency")
    .map((task) => ({
      ...task,
      nextDate: task.lastCheckedMoment.addDays(task.rule.frequency),
    }));
};

const getTasksByStaticDate = (checkedTasks) => {
  const suitableTasks = checkedTasks.filter(
    (task) => task?.rule?.type === "staticdate"
  );

  const readyTasks = [];
  const readyTasksId = [];

  let date = new Date().addDays(-30);

  while (readyTasks.length < suitableTasks.length) {
    suitableTasks.forEach((task) => {
      const wasCompletedAfterDate =
        date.getTime() < task.lastCheckedMoment.getTime() + oneDayInMiliseconds;

      if (!readyTasksId.includes(task.id) && !wasCompletedAfterDate) {
        const func = new Function("date", task.rule.func);

        if (func(date)) {
          readyTasks.push({ ...task, nextDate: date });
          readyTasksId.push(task.id);
        }
      }
    });

    date = date.addDays(1);
  }

  return readyTasks;
};

export const getTasks = async () => {
  const checkedTasks = await loadChecked();

  const tasksGottenByFrequency = getTasksByFrequency(checkedTasks);
  const tasksGottenByStaticDate = getTasksByStaticDate(checkedTasks) ?? [];

  const dirtyArray = [...tasksGottenByFrequency, ...tasksGottenByStaticDate];

  dirtyArray.sort((a, b) => a.nextDate.getTime() - b.nextDate.getTime());

  const cleanArray = dirtyArray.map(({ id, title, nextDate, link }) => {
    const cleanTask = {
      id,
      title,
      nextDate,
    };

    if (link || typeof link === 'string') {
      cleanTask.link = link;
    }

    return cleanTask
  });

  const finalTasks = {
    overdue: [],
    upcoming: [],
    thisWeek: [],
    farFuture: [],
  };

  cleanArray.forEach((task) => {
    const nextDate = getFluffedStamp(task.nextDate);
    const now = new Date();

    switch (true) {
      case nextDate < getFluffedStamp(now):
        finalTasks.overdue.push(task);
        break;

      case nextDate < getFluffedStamp(now.addDays(3)):
        finalTasks.upcoming.push(task);
        break;

      case nextDate < getFluffedStamp(now.addDays(8)):
        finalTasks.thisWeek.push(task);
        break;

      default:
        finalTasks.farFuture.push(task);
        break;
    }
  });

  return finalTasks;
};

const uglifyTasks = (tasks) => tasks.map(({id, lastCheckedMoment, checkedMoments}) => ({
  id,
  lsm: getFluffedStamp(lastCheckedMoment),
  cm: checkedMoments.map(date => getFluffedStamp(date))
}))

export const postTaskCompleted = async (taskID, moment = Date.now()) => {
  const checkedTasks = await loadChecked();

  let currentInChecked = checkedTasks.find(({ id }) => taskID === id);

  const lastCheckedMoment = new Date(moment);

  currentInChecked.lastCheckedMoment = lastCheckedMoment;
  currentInChecked.checkedMoments.push(lastCheckedMoment);

  lStorage.set("stats/accumulative", uglifyTasks(checkedTasks));

  return true;
};
